/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTariffInfo,
    JsonTariffInfoFromJSON,
    JsonTariffInfoFromJSONTyped,
    JsonTariffInfoToJSON,
} from './JsonTariffInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonTariffInfo
 */
export interface ApiResultOfListOfJsonTariffInfo {
    /**
     * 
     * @type {Array<JsonTariffInfo>}
     * @memberof ApiResultOfListOfJsonTariffInfo
     */
    data?: Array<JsonTariffInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTariffInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonTariffInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTariffInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTariffInfo
     */
    result?: ApiResultOfListOfJsonTariffInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonTariffInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonTariffInfoFromJSON(json: any): ApiResultOfListOfJsonTariffInfo {
    return ApiResultOfListOfJsonTariffInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonTariffInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonTariffInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonTariffInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonTariffInfoToJSON(value?: ApiResultOfListOfJsonTariffInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonTariffInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

